import React, { createContext, useContext, ReactNode } from 'react'
import { FormSchema } from './Form/Types'
import { MultiStepSchema } from '../schemas/Types'

interface WizardContextProps {
  schema: FormSchema<any> | MultiStepSchema<any>
}

const WizardContext = createContext<WizardContextProps | null>(null)

export const useWizardContext = () => {
  const context = useContext(WizardContext)
  if (!context) {
    throw new Error('useWizardContext must be used within a WizardProvider')
  }
  return context
}

interface WizardProviderProps {
  schema: FormSchema<any> | MultiStepSchema<any>
  children: ReactNode
}

export const WizardProvider = ({ schema, children }: WizardProviderProps) => {
  return <WizardContext.Provider value={{ schema }}>{children}</WizardContext.Provider>
}

export const useWizardSchema = () => {
  const context = useWizardContext()
  return context.schema
}
